import {
  fetchNotificationTypes,
  fetchNotificationPageTypes,
  notificationMarkReadTypes,
  SUBSCRIBE_TO_NOTIFICATION,
} from './action_types';

import {
  FETCH_NOTIFICATION_QUERY,
  NOTIFICATION_MARK_READ_MUTATION,
  NOTIFICATION_ADDED_SUBSCRIPTION,
} from './api';

import { makeQuery, makeMutation, makeSubscription } from '../../config/client';

export const fetchNotification = variables => makeQuery(variables)(
  fetchNotificationTypes,
  FETCH_NOTIFICATION_QUERY
);

export const fetchNotificationPage = variables => makeQuery(variables)(
  fetchNotificationPageTypes,
  FETCH_NOTIFICATION_QUERY
);

export const notificationMarkRead = variables => makeMutation({ variables })(
  notificationMarkReadTypes,
  NOTIFICATION_MARK_READ_MUTATION
);

export const subscribeToNotification = variables => makeSubscription({
  variables,
  name: 'notificationAdded',
})(
  SUBSCRIBE_TO_NOTIFICATION,
  NOTIFICATION_ADDED_SUBSCRIPTION
);



// WEBPACK FOOTER //
// ./src/modules/notification/actions.js